import UploadImage from '@/components/upload-image/index.vue';
import PurchaseBusinessService from '../../purchase-business-service';
import { errorMessage, successMessage } from '@/utils/message.js';

export default {
  components: {
    UploadImage
  },
  data() {
    return {
      iframeUrl: '',
      id: '',
      amount: '',
      activeNav: 1,
      imgEnumType: 10,
      detail: {},
      serviceFund: {},
      performanceFund: {},
      workersFund: {},
      engineeringFund: {},
      ruleForm: {
        filePaths: [],
        inputValue: null,
        fund: '',
        remark: ''
      },
      voucherList: [{
        urls: [],
        imgEnumType: 10
      }],
      rules: {
        inputValue: [
          { required: true, message: '请上传付款凭证', trigger: 'change' }
        ]
      },
      isProjectDeposit: false // 是否为工程保证金
    };
  },
  created () {
    // 后端防双击
    this.$store.dispatch('generatorClickToken');
    this.id = this.$route.query.id;
    if (this.id) {
      this.isProjectDeposit = this.$route.query.transactionType ? true : false;
      this.$store.commit('RESET_NAV_LIST');
      if (this.isProjectDeposit) {
        this.$store.commit('SET_NAV_LIST', [{path: '/index', title: '首页'},
          {path: '/person-center', title: '个人中心'}, {path: '/person-center/purchase-business/contracting-project/list', title: '成交采购项目'},
          {path: '/person-center/purchase-business/contracting-project/contracting-pay-list', title: '支付工程质保金'}]);
      } else {
        this.$store.commit('SET_NAV_LIST', [{path: '/index', title: '首页'},
          {path: '/person-center', title: '个人中心'}, {path: '/person-center/purchase-business/contracting-project/list', title: '成交采购项目'},
          {path: '/person-center/purchase-business/contracting-project/contracting-pay-list', title: '支付项目款'}]);
      }
      this.paymentProjectFundInfo();
    }
  },
  methods: {
    changeActiveNav (key) {
      this.activeNav = key;
      // 线上支付
      if(Number(key) === 2) {
        let paymentParams = {
          projectBidCode: this.detail.projectBidCode,
          amount: this.detail.transactionAmount, // 交易金额
          bidNo: this.detail.projectBidCode,     // 标的编号
          cashierType: 'PC',   // 收银台类型(PC端/移动端)
          transactionType: this.isProjectDeposit ? 12 : 10, // 2 保证金； 10 合同款、履约保证金；12 工程质保金
          acctNo: this.detail.draweeAccount // 付款方银行账号
        };
        this.$store.dispatch('onlinePayment', paymentParams).then((res) => {
          this.iframeUrl = res.data.bankNoURL;
        }, error => {
          if (error && error.reason) {
            errorMessage(error.reason);
          }
        });
      }
    },
    changeFee (key) {
      console.log(key);
      this.imgEnumType = key;
      this.voucherList[0].imgEnumType = key;
    },
    paymentProjectFundInfo() {
      const type = this.$route.query.transactionType ? 12: 10;
      PurchaseBusinessService.paymentProjectFundInfo(this.id, type).then(res => {
        if (res && res.code === '0') {
          this.detail = res && res.data;
          this.serviceFund = this.detail.serviceFund;
          this.performanceFund = this.detail.performanceFund;
          this.workersFund = this.detail.workersFund;
          this.engineeringFund = this.detail.engineeringFund;
        }
      });
    },
    uploadImage (event) {
      this.ruleForm.filePaths = event;
      this.voucherList[0].urls = [];
      if (event.length) {
        this.ruleForm.inputValue = event.length;
        for (let i = 0; i < event.length; i++) {
          (this.voucherList[0].urls).push(event[i].sourceImgUrl);
        }
      } else {
        this.ruleForm.inputValue = null;
      }
    },
    previousStep () {
      this.$router.back();
    },
    // 线下支付
    test() {
      if(this.imgEnumType === 3){
        this.amount = this.serviceFund.fee;
      }else if(this.imgEnumType === 5){
        this.amount = this.performanceFund.fee;
      }else if(this.imgEnumType === 6){
        this.amount = this.workersFund.fee;
      }else if(this.imgEnumType === 7){
        this.amount = this.engineeringFund.fee;
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否继续提交支付信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const type = this.$route.query.transactionType ? 12: 10;
            PurchaseBusinessService.postPaymentFund({
              transactionType: type,
              purchaseId: this.id,
              voucherList: this.voucherList,
              amount: this.detail.transactionAmount,
              remark: this.ruleForm.remark
            }).then(res => {
              if (res && res.code === '0') {
                successMessage('提交成功');
                this.previousStep();
              } else if (res && res.reason) {
                errorMessage(res && res.reason);
              } else {
                errorMessage('提交失败');
              }
            }, (error) => {
              if (error && error.data && error.data.reason) {
                errorMessage(error.data.reason);
              } else {
                errorMessage('提交失败');
              }
            });
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    }
  }
};
